import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { SsoState } from '../../../store/sso/sso.state';
import { environment } from 'src/environments/environment';

export const notSsoAuthGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  const isAuthenticated = store.selectSnapshot(SsoState.isAuthenticated);
  // Si está autenticado (desde localStorage o estado actual), redirigir a home
  if (isAuthenticated) {
    router.navigateByUrl('/home');
    return false;
  }

  // Si hay query params (tokens del SSO), permitir acceso al callback
  if (window.location.search) {
    return true;
  }
  // Si no hay autenticación ni tokens, redirigir a SSO
  window.location.href = `${environment.sso.url}`;
  return false;
};
